import { useQuery } from "@tanstack/react-query";
import { api } from "../client";
import { queryKeys } from "../query-keys";

export function useMarketComponentArticleTypesSelect() {
  return useQuery({
    queryKey: queryKeys.marketComponentArticleTypes.all,
    queryFn: async () => {
      const res =
        await api.marketComponentArticleTypeApi.apiMarketComponentArticleTypesGetCollection();
      return res.data;
    },
    meta: {
      skipGlobalError: false,
    },
  });
}
